import styled, { css } from "styled-components";
import { ids } from "@icarros/theme-react";
const { color, size, spacing } = ids || {};
const horizontalStyle = css `
  justify-content: flex-end;
`;
const verticalStyle = css `
  justify-content: space-between;
  button {
    width: 100%;
  }
`;
const sidedStyle = css `
  gap: ${spacing.ids_spacing_4x};
`;
const pilledStyle = css `
  flex-wrap: wrap;
  gap: ${spacing.ids_spacing_3x};
`;
const stickyStyle = css `
  position: sticky;
  bottom: 0;
  margin: 0 -${spacing.ids_spacing_6x} 0 -${spacing.ids_spacing_6x};
  padding-block: ${spacing.ids_spacing_6x};
  background-color: ${color.backgrounds.ids_color_bg_base};
  border-top: ${size.border_width.ids_size_border_small}
    ${color.border.ids_color_border_soft} solid;
  & button {
    margin: 0 ${spacing.ids_spacing_6x} 0 ${spacing.ids_spacing_6x};
  }
`;
const getModalTypeCss = (modalType) => {
    switch (modalType) {
        case "horizontal":
            return horizontalStyle;
        case "vertical":
            return verticalStyle;
        default:
            return verticalStyle;
    }
};
export const ModalFooterContainer = styled.div `
  display: flex;
  margin-top: ${spacing.ids_spacing_6x};
  ${({ modalType }) => getModalTypeCss(modalType)};
  ${({ buttonType }) => (buttonType === "pilled" ? pilledStyle : sidedStyle)};
  ${({ isSticky }) => (isSticky ? stickyStyle : "")};
`;
//# sourceMappingURL=ModalFooter.style.js.map